import React, { createContext, useReducer } from 'react';

const initialState = {};
const insightsContext = createContext(initialState);
const { Provider } = insightsContext;

const InsightProvider = ({ children }) => {
  const [state, dispatch] = useReducer((contextState, action) => {
    const typeOptions = {
      ADD_INSIGHTS: {
        ...contextState,
        data: action.data,
        currentInsight: 0,
        profile: action.profile,
      },
      SET_INSIGHT: {
        ...contextState,
        currentInsight: action.index,
      },
      SET_ARCCOS_VERIFIED: {
        ...contextState,
        verified: action.verified,
        acceptedTerms: action.acceptedTerms,
      },
      SET_DATA_ERROR: {
        ...contextState,
        dataError: true,
      },
      ACCEPT_TERMS: {
        ...contextState,
        acceptedTerms: true,
      },
    };

    if (typeOptions[action.type]) {
      return typeOptions[action.type];
    }

    throw new Error();
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { insightsContext, InsightProvider };
